<div class="error-display-container">
  <div class="error-header">
    <h1>Authentication Error</h1>
    <p>We encountered an issue while processing your request.</p>
  </div>

  @if (errors.length > 0) {
    <div class="error-list">
      @for (error of errors; track error) {
        <div class="error-item">
          <div class="error-message">
            <strong>{{ error.message }}</strong>
          </div>
          @if (error.error || error.error_description) {
            <div class="error-details">
              @if (error.error) {
                <p><strong>Error:</strong> {{ error.error }}</p>
              }
              @if (error.error_description) {
                <p><strong>Description:</strong> {{ error.error_description }}</p>
              }
            </div>
          }
          <div class="error-timestamp">
            <small>{{ error.timestamp | date:'medium' }}</small>
          </div>
        </div>
      }
    </div>
  }

  <div class="error-actions">
    <button class="btn btn-primary" (click)="goToHome()">Return to Home</button>
  </div>
</div>
